import { Injectable, inject } from '@angular/core';

import { NativePrice, NativePriceFormatterService } from '@frontend/sports/odds/feature/native-price';

@Injectable({ providedIn: 'root' })
export class DecimalsPriceFormatterService {
    private nativeFormatter = inject(NativePriceFormatterService);

    /**
     * @param  value - The odds value.
     * @returns  - the formatted odds in odds setting display format
     */
    format(value: number) {
        const price = NativePrice.fromDecimalsElement(value, true);

        return this.nativeFormatter.format(price);
    }
}
